import { render, staticRenderFns } from "./rule-layout.vue?vue&type=template&id=56f0afc1&scoped=true"
import script from "./rule-layout.vue?vue&type=script&lang=js"
export * from "./rule-layout.vue?vue&type=script&lang=js"
import style0 from "./rule-layout.vue?vue&type=style&index=0&id=56f0afc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f0afc1",
  null
  
)

export default component.exports